import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { cn } from '../lib/utils';
type Props = {
  children: React.ReactNode;
  className?: string;
  href?: string;
  size?: 'md' | 'lg';
};
export const CHECKOUT_URL = 'https://100-ai-prompts-for-firefighters.impultienda.ar/checkout';
export function CTAButton({
  children,
  className = '',
  href = CHECKOUT_URL,
  size = 'lg'
}: Props) {
  const pad = size === 'lg' ? 'min-h-[60px] px-7 py-4 text-[16px] sm:text-[17px]' : 'min-h-[56px] px-6 py-3.5 text-[15px] sm:text-base';
  return <a href={href} className={cn('group inline-flex w-full max-w-[420px] items-center justify-center gap-2.5 rounded-xl bg-crimson text-center font-display font-extrabold leading-snug text-ice [text-wrap:balance]', 'shadow-[0_10px_28px_-12px_rgba(230,57,70,0.75),inset_0_1px_0_rgba(255,255,255,0.18)]', 'transition-[background-color,box-shadow,transform] duration-200 ease-out hover:bg-crimson-bright hover:shadow-[0_14px_34px_-12px_rgba(240,79,91,0.85),inset_0_1px_0_rgba(255,255,255,0.2)] active:scale-[0.98]', 'focus:outline-none focus-visible:ring-2 focus-visible:ring-ice focus-visible:ring-offset-2 focus-visible:ring-offset-obsidian', pad, className)} data-id="element-38" data-mp="2oy70tw54gw99">
      {children}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-39" data-mp="1n8xsj8sdbptk" />
    </a>;
}